module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-2450.0421e145.svg";